/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_Tier_Lists_TitleInputs */



/**
* | output |
* | --- |
* | "Tier Lists" |
*
* @param {Help_Article_Tier_Lists_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_tier_lists_title = /** @type {((inputs?: Help_Article_Tier_Lists_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_Tier_Lists_TitleInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tier-Listen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tier lists")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("梯度表")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("分級表")
	if (locale === "ko") return /** @type {LocalizedString} */ ("티어 리스트")
	return /** @type {LocalizedString} */ ("Tier Lists")
});